var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNoPain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9133 59.7475C49.1203 59.7475 59.8266 49.0412 59.8266 35.8342C59.8266 22.6273 49.1203 11.9209 35.9133 11.9209C22.7064 11.9209 12 22.6273 12 35.8342C12 49.0412 22.7064 59.7475 35.9133 59.7475Z",
    fill: "url(#paint0_linear_3589_6217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9137 15.1094C24.486 15.1096 15.1891 24.4071 15.1895 35.8348C15.1853 40.7803 16.9575 45.5628 20.1833 49.3115L49.3907 20.1025C45.6419 16.8769 40.8592 15.1049 35.9137 15.1094ZM51.6454 22.3569L22.4379 51.566C26.1866 54.7916 30.9693 56.5635 35.9148 56.5591C47.3426 56.5588 56.6394 47.2614 56.6391 35.8336C56.6433 30.8881 54.8711 26.1056 51.6454 22.3569Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1543 13.209L28.1556 59.7477H28.1543V13.209Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3589_6217",
    x1: 71.6736,
    y1: 59.7448,
    x2: 14.1939,
    y2: 59.7448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoPain);
export default __webpack_public_path__ + "static/media/ic-no-pain.39e65384a6ad2643064bf1c3c0cd5d72.svg";
export { ForwardRef as ReactComponent };